module.exports = __webpack_public_path__ + "img/bit_recharge_icon.869a5898.svg";